import axios from '@/axios'

export default {
  getRoles({ commit }, payload) {
    const { limit, page, order, search } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .get('/role', {
          params: {
            limit,
            page,
            order,
            search
          }
        })
        .then(function(response) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          commit('SET_STATE', {
            action: 'roles',
            data: response.data.data
          })
          commit('SET_STATE', {
            action: 'total',
            data: response.data.totalCount
          })
          commit('SET_STATE', {
            action: 'FilteredCount',
            data: response.data.FilteredCount
          })
          resolve({
            data: response.data.data,
            FilteredCount: response.data.FilteredCount,
            total: response.data.totalCount
          })
        })
        .catch(function(error) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          reject(error.message)
        })
    })
  },
  async insert({ commit }, payload) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/role', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: res.data.message }
    } catch (err) {
      const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return Promise.reject({ message })
    }
  },
  async delete({ commit }, id) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.delete(`/role/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: res.data.data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return Promise.reject(err.response.data)
    }
  },
  async get({ commit }, id) {
    try {
      const res = await axios.get(`/role/${id}`)
      commit('SET_STATE', {
        action: 'permissions',
        data: res.data.permissions
      })
      return res.data
    } catch (err) {
      return Promise.reject(err.response.data)
    }
  },
  async update({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/role/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: res.data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },
  updateStatus({ commit }, { id, status }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .put(`/role/${id}/update-status`, {
          status
        })
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            errors: Object.values(err.response.data.meta),
            message
          })
        })
    })
  },
  async getPermissions({ commit }) {
    try {
      const res = await axios.get('/permission')
      commit('SET_STATE', {
        action: 'permissions',
        data: res.data.data.permissions
      })
    } catch (err) {
      return Promise.reject(err.response.data)
    }
  },
  getParentRoleList: async () => {
    try {
      const res = await axios.get('role/parent-roles')

      return {
        data: res.data.parentRoles.map(parentRole => ({
          value: parentRole.id,
          label: parentRole.role_name
        }))
      }
    } catch (err) {
      return Promise.reject(err.response.data)
    }
  },
  getRoleGroup: async () => {
    try {
      const res = await axios.get('role/find-role-group')

      const roleGroup = []
      for (const role of res.data || []) {
        roleGroup.push({
          value: role.id,
          label: role.role_name
        })
      }

      return {
        data: roleGroup
      }
    } catch (err) {
      return Promise.reject(err.response.data)
    }
  }
}
